/**
 * @param {string} hex — #rrggbb
 * @param {number} alpha
 * @return {string}
 */
export function withAlpha(hex, alpha) {
  if (!hex || typeof hex !== "string") {
    return `rgba(100, 116, 139, ${alpha})`;
  }
  const normalized = hex.replace("#", "");
  if (normalized.length !== 6) {
    return `rgba(100, 116, 139, ${alpha})`;
  }
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 * @param {string} hex
 * @return {{ tileBg: string, tileBorder: string, tileShadow: string, edgeStroke: string }}
 */
export function accentSurfaces(hex) {
  const base = hex || "#64748b";
  return {
    tileBg: `linear-gradient(165deg, ${withAlpha(base, 0.2)} 0%, ${withAlpha(base, 0.06)} 48%, #ffffff 100%), #ffffff`,
    tileBorder: withAlpha(base, 0.28),
    tileBorderFocus: withAlpha(base, 0.55),
    tileShadow: `0 4px 14px ${withAlpha(base, 0.22)}`,
    edgeStroke: withAlpha(base, 0.42),
    edgeStrokeMuted: withAlpha(base, 0.22),
    label: withAlpha(base, 0.92),
    pillBg: `linear-gradient(165deg, ${withAlpha(base, 0.22)} 0%, ${withAlpha(base, 0.08)} 55%, #ffffff 100%), #ffffff`,
    pillBorder: withAlpha(base, 0.35),
    pillText: base,
  };
}
